export default __webpack_public_path__ + "static/media/edit.ac8aef32.svg";